<section class="actions-bar" *ngIf="isLicenceManager">
    <a *ngIf="!isLoading" mat-raised-button color="accent" class="back-button" routerLink="../">
        <mat-icon aria-label="Back">keyboard_arrow_left</mat-icon>
        {{ 'main.nav.links.licences.shortLabel' | translate }}
    </a>
    <button *ngIf="!isLoading" mat-raised-button color="accent" class="export-btn" (click)="onExport()">
        <mat-icon aria-label="File">insert_drive_file</mat-icon>
        {{ 'reports.exports.xls.shortLabel' | translate }}
    </button>
    <mat-spinner *ngIf="isLoading" [diameter]="35" color="accent" ></mat-spinner>
</section>

<app-licence-summary *ngIf="isLicenceManager" [licence]="licence"></app-licence-summary>
<app-roles-list [rolesList]="licence.roles" [isEditAllowed]="isLicenceManager"></app-roles-list>
<app-users-list *ngIf="licence.roles.length" [usersList]="licence.users" [isEditAllowed]="isUsersManager"></app-users-list>
